// Common princing functions
import { setCookie, readCookie } from './cookies';
import { triggerChange } from "./eventTarget";
import { getUserCountryByIp } from "./userIp";
const OTActive = (typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0001")) ? true : false;
const currencySelector = document.querySelector('.currency');
let time = 500;
if (location.host === 'local-new.fromdoppler.com' || location.host === 'localhost') {
  time = 1500
}


const addCommas = (nStr) => {
  const lang = document.documentElement.lang;
  const charSeparate = lang === 'en' ? ',' : '.';
  const lastCharSeparate = lang === 'en' ? '.' : ',';

  // Aseguramos que nStr es un string
  nStr = nStr.toString();

  // Dividimos el número en parte entera y decimal
  const [integerPart, decimalPart] = nStr.split('.');

  // Eliminamos separadores previos de la parte entera
  const cleanIntegerPart = integerPart.replace(/[,.]/g, '');

  // Formateamos la parte entera con separadores
  const formattedInteger = cleanIntegerPart.replace(/\B(?=(\d{3})+(?!\d))/g, charSeparate);

  // Reconstruimos el número con la parte decimal, si existe
  return decimalPart !== undefined
    ? `${formattedInteger}${lastCharSeparate}${decimalPart}`
    : formattedInteger;
};


const readCurrentCurrencyCookieValue = () => {
  const raw = readCookie('currentCurrency');
  if (raw === null) return null;
  try {
    const { value } = JSON.parse(raw);
    // Solo una cadena de texto puede compararse y buscarse igual en los dos módulos;
    // cualquier otro tipo se coacciona distinto en cada uno y vuelve a separarlos.
    return typeof value === 'string' ? value : null;
  } catch (error) {
    return null;
  }
}

function setCookieWithSelector(selector) {
  let selectedIndex = selector.options.selectedIndex;
  if (selector.options[selectedIndex] === undefined) return;
  let currencyName = selector.value,
    currencySymbol = selector.options[selectedIndex].getAttribute("data-currency"),
    currencyRate = selector.options[selectedIndex].getAttribute("data-rate");

  if (OTActive) { // Functional Cookies
    setCookie('currencySelector', currencyName);
  }

  if (currencyName !== undefined && currencyName !== null) {
    var currentCurrency = {
      value: currencyName,
      symbol: currencySymbol,
      rate: currencyRate,
    };

    setCookie('currentCurrency', JSON.stringify(currentCurrency));
  }
}


const COUNTRIES_WITH_LOCAL_CURRENCY = ['AR', 'BO', 'BR', 'CL', 'CO', 'DO', 'MX', 'PY', 'PE', 'UY', 'VE'];
// Países miembros de la Unión Europea, por código ISO. EUR se decide a partir del país
// detectado y nunca de la zona horaria del navegador, que un viaje o una VPN vuelven engañosa.
const EURO_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

const getCountryCurrencyName = (countryAbbreviatedName) => {
  let name = '';
  switch (countryAbbreviatedName) {
    case 'AR':
      name = 'ARS';
      break;
    case 'BO':
      name = 'BOB';
      break;
    case 'BR':
      name = 'BRL';
      break;
    case 'CL':
      name = 'CLP';
      break;
    case 'CO':
      name = 'COP';
      break;
    case 'DO':
      name = 'DOP';
      break;
    case 'MX':
      name = 'MXN';
      break;
    case 'PY':
      name = 'PYG';
      break;
    case 'PE':
      name = 'PEN';
      break;
    case 'UY':
      name = 'UYU';
      break;
    case 'VE':
      name = 'VES';
      break;
    default:
      name = 'USD';
  }
  return name;
}

// Única fuente de verdad para país -> moneda. Cae a USD, que es la moneda base
// en la que se renderizan las plantillas de precios.
const resolveCurrencyByCountry = (countryCode) => {
  if (COUNTRIES_WITH_LOCAL_CURRENCY.includes(countryCode)) {
    return getCountryCurrencyName(countryCode);
  }
  return EURO_COUNTRIES.includes(countryCode) ? 'EUR' : 'USD';
}

const setUserCurrencyByCountry = ({ countryName, countryCode }) => {
  const currencyName = resolveCurrencyByCountry(countryCode);

  setCookie('currencySelector', currencyName);
  if (currencySelector != undefined || currencySelector != null) {
    currencySelector.value = currencyName;
    setTimeout(() => { triggerChange(currencySelector); }, time);
  }
}

const setUserCurrencyByIp = () => {
  // Una consulta fallida igual tiene que aterrizar en algún lado: sin esto el selector de SMS
  // se queda en la primera opción del proxy mientras el módulo principal ya resolvió a USD.
  getUserCountryCached().then(countryCode => setUserCurrencyByCountry({ countryCode }));
}

const getCurrenciesValues = async () => {
  const lang = document.documentElement.lang;
  const url = '/backend/pricing/currenciesProxy.php?getLatestCurrencies=true&productFilter=DOPPLER&language=' + lang;
  const resp = await fetch(url);
  const data = await resp.json();
  return data;
}

const getSpecialOfferDiscountValue = () => {
  return document.getElementById('specialOfferDiscount').value;
}

const getSpecialOfferMaxContactsValue = () => {
  return parseInt(document.getElementById('specialOfferMaxContacts').value);
}


const createUserCountryCache = () => {
	let pendingUserCountry = null;
	return () => {
		// Memoiza la promesa, incluido el fallo, para que todas las llamadas de esta carga de página
		// compartan una sola consulta. Reintentar tras un fallo dejaba a los dos consumidores
		// resolviendo monedas distintas, peor que el caso en que ambos caen a USD.
		if (pendingUserCountry === null) {
			pendingUserCountry = getUserCountryByIp()
				.then(async (response) => JSON.parse(await response.text()).countryCode)
				.catch((error) => {
					console.error('Error obteniendo el país por IP:', error);
					return null;
				});
		}
		return pendingUserCountry;
	};
};

const getUserCountryCached = createUserCountryCache();

export {
  addCommas,
  setCookieWithSelector,
  getCountryCurrencyName,
  resolveCurrencyByCountry,
  getUserCountryCached,
  setUserCurrencyByCountry,
  setUserCurrencyByIp,
  getCurrenciesValues,
  getSpecialOfferDiscountValue,
  getSpecialOfferMaxContactsValue,
  createUserCountryCache,
  readCurrentCurrencyCookieValue
};
